import BaseIcon from "./BaseIcon"

const ChatPlusIcon = ({
	size = "24px",
	fill = "#ACACAC",
	className,
}: {
	size?: string
	fill?: string
	className?: string
}) => {
	return (
		<BaseIcon
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			className={className}
		>
			<path
				d="M12 2C17.523 2 22 6.477 22 12C22 12.263 21.99 12.523 21.97 12.78C21.5299 12.3632 21.0338 12.0098 20.496 11.73C20.4546 10.4441 20.1218 9.18438 19.5227 8.0458C18.9236 6.90722 18.0739 5.91949 17.0375 5.15706C16.0012 4.39464 14.8053 3.87741 13.54 3.64437C12.2748 3.41133 10.9731 3.46856 9.73312 3.81174C8.49316 4.15492 7.34728 4.77511 6.38187 5.62554C5.41645 6.47597 4.65668 7.53446 4.15983 8.72122C3.66298 9.90798 3.44201 11.192 3.51358 12.4766C3.58515 13.7612 3.9474 15.0128 4.57301 16.137L4.72301 16.407L3.61101 20.391L7.59801 19.279L7.86801 19.429C9.05117 20.0892 10.3757 20.4551 11.73 20.496C12.011 21.036 12.366 21.532 12.78 21.97C10.9247 22.118 9.0651 21.7431 7.41201 20.888L3.58701 21.955C3.37355 22.0146 3.14809 22.0163 2.93373 21.9601C2.71937 21.9038 2.52382 21.7916 2.36712 21.6349C2.21041 21.4782 2.09818 21.2826 2.04194 21.0683C1.98569 20.8539 1.98744 20.6285 2.04701 20.415L3.11501 16.592C2.38036 15.1729 1.99793 13.5979 2.00001 12C2.00001 6.477 6.47701 2 12 2ZM23 17.5C23 16.0413 22.4205 14.6424 21.3891 13.6109C20.3576 12.5795 18.9587 12 17.5 12C16.0413 12 14.6424 12.5795 13.6109 13.6109C12.5795 14.6424 12 16.0413 12 17.5C12 18.9587 12.5795 20.3576 13.6109 21.3891C14.6424 22.4205 16.0413 23 17.5 23C18.9587 23 20.3576 22.4205 21.3891 21.3891C22.4205 20.3576 23 18.9587 23 17.5ZM18 18L18.001 20.503C18.001 20.6356 17.9483 20.7628 17.8546 20.8566C17.7608 20.9503 17.6336 21.003 17.501 21.003C17.3684 21.003 17.2412 20.9503 17.1475 20.8566C17.0537 20.7628 17.001 20.6356 17.001 20.503V18H14.496C14.3634 18 14.2362 17.9473 14.1425 17.8536C14.0487 17.7598 13.996 17.6326 13.996 17.5C13.996 17.3674 14.0487 17.2402 14.1425 17.1464C14.2362 17.0527 14.3634 17 14.496 17H17V14.5C17 14.3674 17.0527 14.2402 17.1465 14.1464C17.2402 14.0527 17.3674 14 17.5 14C17.6326 14 17.7598 14.0527 17.8536 14.1464C17.9473 14.2402 18 14.3674 18 14.5V17H20.497C20.6296 17 20.7568 17.0527 20.8506 17.1464C20.9443 17.2402 20.997 17.3674 20.997 17.5C20.997 17.6326 20.9443 17.7598 20.8506 17.8536C20.7568 17.9473 20.6296 18 20.497 18H18Z"
				fill={fill}
			/>
		</BaseIcon>
	)
}

export default ChatPlusIcon
